import { chunk } from "@suse-o11y/chunk";
import { clamp } from "@suse-o11y/clamp";
import React, { useMemo, useState } from "react";

import type { TimeSeries } from "../../TimeSeriesChart/time-series";

function useTimeSeriesPages(
	pageSize: number,
	timeSeries: ReadonlyArray<TimeSeries>,
): [
	pages: ReadonlyArray<ReadonlyArray<TimeSeries>>,
	index: number,
	setIndex: React.Dispatch<React.SetStateAction<number>>,
] {
	const [pageIndex, setPageIndex] = useState(0);

	const pages = useMemo(
		() => (timeSeries.length === 0 || pageSize === 0 ? [] : chunk(timeSeries, pageSize)),
		[timeSeries, pageSize],
	);

	const normalizedIndex = pages.length < 1 ? 0 : clamp(pageIndex, { min: 0, max: pages.length - 1 });

	return [pages, normalizedIndex, setPageIndex];
}

export { useTimeSeriesPages };
